import { api } from './api';

const endpoint = '/dash/shops';

export const apiShops = {

  async list(options_query = ""){
    const url = `${endpoint}/all?${options_query}`;
    const result = await api.get(url);
    return result.data;
  },

  async get(id){
    const url = `${endpoint}/${id}`;
    const result = await api.get(url);
    return result.data;
  },

  async create(data){
    const url = `${endpoint}/new`;
    const result = await api.post(url, data);
    return result.data;
  },

  async update(data){
    const url = `${endpoint}/update`;
    const result = await api.post(url, data);
    return result.data;
  },

  async deactivate(id){
    const url = `${endpoint}/deactivate/${id}`;
    const result = await api.get(url);
    return result.data;
  },

  async delete(id){
    const url = `${endpoint}/delete/${id}`;
    await api.get(url);
  },  

  async check_connection(){
    const url=`${endpoint}/check-connection`;
    const result = await api.get(url);
    return result.data;
  },

  async search(query){
    const url = `${endpoint}/search/${query}`;
    const result = await api.get(url);
    return result.data;
  },

  async template(){
    const url=`${endpoint}/template-index`;
    const result = await api.get(url);
    return result.data;
  }

}